/**
 * Get size cover
 * @param 'cover'|'contain' type Size type.
 * @param integer imgWidth Img width.
 * @param integer imgHeight Img height.
 * @param integer containerWidth Container width.
 * @param integer containerHeight Container height.
 */
export default function getSize(type, imgWidth, imgHeight, containerWidth, containerHeight) {
  let width = 0;
  let height = 0;

  const posibilities = {
    contain: [
      !!(
        containerWidth > containerHeight &&
        imgWidth > imgHeight &&
        (imgWidth * containerHeight) / imgHeight < containerWidth
      ),
      !!(containerWidth > containerHeight && imgWidth <= imgHeight),
      !!(
        containerWidth <= containerHeight &&
        imgWidth < imgHeight &&
        (imgWidth * containerHeight) / imgHeight < containerWidth
      ),
      !!(containerWidth === containerHeight && imgWidth === imgHeight),
    ],
    cover: [
      !!(
        containerWidth > containerHeight &&
        imgWidth > imgHeight &&
        (imgWidth * containerHeight) / imgHeight > containerWidth
      ),
      !!(containerWidth <= containerHeight && imgWidth > imgHeight),
      !!(
        containerWidth < containerHeight &&
        imgWidth <= imgHeight &&
        (imgWidth * containerHeight) / imgHeight > containerWidth
      ),
      !!(containerWidth === containerHeight && imgWidth === imgHeight),
    ],
  };

  if (
    (posibilities.contain.includes(true) && type === 'contain') ||
    (posibilities.cover.includes(true) && type === 'cover')
  ) {
    width = (imgWidth * containerHeight) / imgHeight;
    height = (imgHeight * width) / imgWidth;
  } else {
    height = (imgHeight * containerWidth) / imgWidth;
    width = (imgWidth * height) / imgHeight;
  }

  return {
    width,
    height,
  };
}
